"use client";

import { c as _c } from "react/compiler-runtime";
import { FiShield, FiBarChart2 } from "react-icons/fi";
const ClinicalConfidence = t0 => {
  const $ = _c(94);
  const {
    confidenceScore,
    confidenceCategory,
    handleConfidenceChange,
    productName,
    onBack,
    onNext
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-2 sm:gap-3 mb-2"><div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-primary-primaryBlue/10 flex items-center justify-center flex-shrink-0"><FiShield className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-primary-primaryBlue" /></div><h2 className="text-base sm:text-xl font-bold text-gray-900 font-poppins">Clinical Confidence</h2></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = productName || "this product";
  let t3;
  if ($[1] !== t2) {
    t3 = <p className="text-xs sm:text-sm text-gray-600 font-poppins mb-4 sm:mb-6">How confident are you that <span className="font-semibold">{t2}</span> will achieve significant clinical outcomes in real-world practice?</p>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== handleConfidenceChange) {
    t4 = e => handleConfidenceChange(Number(e.target.value));
    $[3] = handleConfidenceChange;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = confidenceScore <= 0 ? "#E0E0E0" : confidenceScore <= 25 ? `linear-gradient(to right, #F59E0B 0%, #F59E0B ${confidenceScore}%, #E0E0E0 ${confidenceScore}%, #E0E0E0 100%)` : confidenceScore <= 50 ? `linear-gradient(to right, #F59E0B 0%, #6A5ACD 25%, #6A5ACD ${confidenceScore}%, #E0E0E0 ${confidenceScore}%, #E0E0E0 100%)` : confidenceScore <= 75 ? `linear-gradient(to right, #F59E0B 0%, #6A5ACD 25%, #1E5EFF 50%, #1E5EFF ${confidenceScore}%, #E0E0E0 ${confidenceScore}%, #E0E0E0 100%)` : `linear-gradient(to right, #F59E0B 0%, #6A5ACD 25%, #1E5EFF 50%, #00BE52 75%, #00BE52 ${confidenceScore}%, #E0E0E0 ${confidenceScore}%, #E0E0E0 100%)`;
  let t6;
  if ($[5] !== t5) {
    t6 = {
      background: t5
    };
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== confidenceScore || $[8] !== t4 || $[9] !== t6) {
    t7 = <input type="range" min="0" max="100" step="1" value={confidenceScore} onChange={t4} className="w-full h-2 rounded-full appearance-none cursor-pointer confidence-slider" style={t6} />;
    $[7] = confidenceScore;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== handleConfidenceChange) {
    t8 = () => handleConfidenceChange(0);
    $[11] = handleConfidenceChange;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = confidenceScore === 0 ? "#1E5EFF" : "#A0A0A0";
  let t10;
  if ($[13] !== t9) {
    t10 = {
      color: t9
    };
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  let t12;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="font-medium">0</div>;
    t12 = <div className="text-[8px] sm:text-[10px]">Unlikely</div>;
    $[15] = t11;
    $[16] = t12;
  } else {
    t11 = $[15];
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t10 || $[18] !== t8) {
    t13 = <button type="button" onClick={t8} className="text-center cursor-pointer hover:text-primary-primaryBlue transition-colors" style={t10}>{t11}{t12}</button>;
    $[17] = t10;
    $[18] = t8;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== handleConfidenceChange) {
    t14 = () => handleConfidenceChange(25);
    $[20] = handleConfidenceChange;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  const t15 = confidenceScore === 25 ? "#1E5EFF" : "#A0A0A0";
  let t16;
  if ($[22] !== t15) {
    t16 = {
      color: t15
    };
    $[22] = t15;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  let t18;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="font-medium">25</div>;
    t18 = <div className="text-[8px] sm:text-[10px]">Rarely</div>;
    $[24] = t17;
    $[25] = t18;
  } else {
    t17 = $[24];
    t18 = $[25];
  }
  let t19;
  if ($[26] !== t14 || $[27] !== t16) {
    t19 = <button type="button" onClick={t14} className="text-center cursor-pointer hover:text-primary-primaryBlue transition-colors" style={t16}>{t17}{t18}</button>;
    $[26] = t14;
    $[27] = t16;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== handleConfidenceChange) {
    t20 = () => handleConfidenceChange(50);
    $[29] = handleConfidenceChange;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  const t21 = confidenceScore === 50 ? "#1E5EFF" : "#A0A0A0";
  let t22;
  if ($[31] !== t21) {
    t22 = {
      color: t21
    };
    $[31] = t21;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  let t23;
  let t24;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <div className="font-medium">50</div>;
    t24 = <div className="text-[8px] sm:text-[10px]">Sometimes</div>;
    $[33] = t23;
    $[34] = t24;
  } else {
    t23 = $[33];
    t24 = $[34];
  }
  let t25;
  if ($[35] !== t20 || $[36] !== t22) {
    t25 = <button type="button" onClick={t20} className="text-center cursor-pointer hover:text-primary-primaryBlue transition-colors" style={t22}>{t23}{t24}</button>;
    $[35] = t20;
    $[36] = t22;
    $[37] = t25;
  } else {
    t25 = $[37];
  }
  let t26;
  if ($[38] !== handleConfidenceChange) {
    t26 = () => handleConfidenceChange(75);
    $[38] = handleConfidenceChange;
    $[39] = t26;
  } else {
    t26 = $[39];
  }
  const t27 = confidenceScore === 75 ? "#1E5EFF" : "#A0A0A0";
  let t28;
  if ($[40] !== t27) {
    t28 = {
      color: t27
    };
    $[40] = t27;
    $[41] = t28;
  } else {
    t28 = $[41];
  }
  let t29;
  let t30;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <div className="font-medium">75</div>;
    t30 = <div className="text-[8px] sm:text-[10px]">Usually</div>;
    $[42] = t29;
    $[43] = t30;
  } else {
    t29 = $[42];
    t30 = $[43];
  }
  let t31;
  if ($[44] !== t26 || $[45] !== t28) {
    t31 = <button type="button" onClick={t26} className="text-center cursor-pointer hover:text-primary-primaryBlue transition-colors" style={t28}>{t29}{t30}</button>;
    $[44] = t26;
    $[45] = t28;
    $[46] = t31;
  } else {
    t31 = $[46];
  }
  let t32;
  if ($[47] !== handleConfidenceChange) {
    t32 = () => handleConfidenceChange(100);
    $[47] = handleConfidenceChange;
    $[48] = t32;
  } else {
    t32 = $[48];
  }
  const t33 = confidenceScore === 100 ? "#1E5EFF" : "#A0A0A0";
  let t34;
  if ($[49] !== t33) {
    t34 = {
      color: t33
    };
    $[49] = t33;
    $[50] = t34;
  } else {
    t34 = $[50];
  }
  let t35;
  let t36;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <div className="font-medium">100</div>;
    t36 = <div className="text-[8px] sm:text-[10px]">Always</div>;
    $[51] = t35;
    $[52] = t36;
  } else {
    t35 = $[51];
    t36 = $[52];
  }
  let t37;
  if ($[53] !== t32 || $[54] !== t34) {
    t37 = <button type="button" onClick={t32} className="text-center cursor-pointer hover:text-primary-primaryBlue transition-colors" style={t34}>{t35}{t36}</button>;
    $[53] = t32;
    $[54] = t34;
    $[55] = t37;
  } else {
    t37 = $[55];
  }
  let t38;
  if ($[56] !== t13 || $[57] !== t19 || $[58] !== t25 || $[59] !== t31 || $[60] !== t37) {
    t38 = <div className="flex justify-between mt-2 text-[10px] sm:text-xs font-poppins">{t13}{t19}{t25}{t31}{t37}</div>;
    $[56] = t13;
    $[57] = t19;
    $[58] = t25;
    $[59] = t31;
    $[60] = t37;
    $[61] = t38;
  } else {
    t38 = $[61];
  }
  let t39;
  if ($[62] !== t38 || $[63] !== t7) {
    t39 = <div className="mb-4"><div className="relative">{t7}{t38}</div></div>;
    $[62] = t38;
    $[63] = t7;
    $[64] = t39;
  } else {
    t39 = $[64];
  }
  const t40 = confidenceScore < 20 ? "#F59E0B" : confidenceScore < 50 ? "#6A5ACD" : confidenceScore < 75 ? "#1E5EFF" : "#00BE52";
  let t41;
  if ($[65] !== t40) {
    t41 = {
      color: t40
    };
    $[65] = t40;
    $[66] = t41;
  } else {
    t41 = $[66];
  }
  let t42;
  if ($[67] !== confidenceScore || $[68] !== t41) {
    t42 = <div className="text-2xl sm:text-3xl font-bold font-poppins" style={t41}>{confidenceScore}%</div>;
    $[67] = confidenceScore;
    $[68] = t41;
    $[69] = t42;
  } else {
    t42 = $[69];
  }
  const t43 = confidenceScore < 20 ? "#F59E0B" : confidenceScore < 50 ? "#6A5ACD" : confidenceScore < 75 ? "#1E5EFF" : "#00BE52";
  let t44;
  if ($[70] !== t43) {
    t44 = {
      backgroundColor: t43
    };
    $[70] = t43;
    $[71] = t44;
  } else {
    t44 = $[71];
  }
  let t45;
  if ($[72] !== confidenceCategory || $[73] !== t44) {
    t45 = <span className="inline-flex items-center px-2 sm:px-3 py-1 sm:py-1.5 text-[10px] sm:text-xs font-bold font-poppins text-white rounded-full shadow-sm" style={t44}>{confidenceCategory}</span>;
    $[72] = confidenceCategory;
    $[73] = t44;
    $[74] = t45;
  } else {
    t45 = $[74];
  }
  let t46;
  if ($[75] !== t42 || $[76] !== t45) {
    t46 = <div className="flex items-end justify-end mt-4 sm:mt-0"><div className="flex flex-col items-end gap-1 sm:gap-2">{t42}{t45}</div></div>;
    $[75] = t42;
    $[76] = t45;
    $[77] = t46;
  } else {
    t46 = $[77];
  }
  let t47;
  if ($[78] !== t39 || $[79] !== t46) {
    t47 = <div className="bg-white rounded-lg border border-gray-200 p-3 sm:p-5">{t39}{t46}</div>;
    $[78] = t39;
    $[79] = t46;
    $[80] = t47;
  } else {
    t47 = $[80];
  }
  let t48;
  if ($[81] !== t3 || $[82] !== t47) {
    t48 = <div className="flex-1 overflow-y-auto hide-scrollbar px-4 sm:px-6 py-3 sm:py-4"><div className="mb-4 sm:mb-6">{t1}{t3}{t47}</div></div>;
    $[81] = t3;
    $[82] = t47;
    $[83] = t48;
  } else {
    t48 = $[83];
  }
  let t49;
  if ($[84] !== onBack) {
    t49 = <button onClick={onBack} className="flex-1 border-2 border-gray-300 text-gray-700 text-sm sm:text-base font-semibold font-poppins rounded-lg py-2.5 sm:py-3 hover:bg-gray-50 transition-colors">Back</button>;
    $[84] = onBack;
    $[85] = t49;
  } else {
    t49 = $[85];
  }
  let t50;
  if ($[86] !== onNext) {
    t50 = <button onClick={onNext} className="flex-1 text-white rounded-lg text-sm sm:text-base font-semibold font-poppins py-2.5 sm:py-3 transition-all bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 shadow-md hover:shadow-lg transform hover:scale-[1.02]">Next</button>;
    $[86] = onNext;
    $[87] = t50;
  } else {
    t50 = $[87];
  }
  let t51;
  if ($[88] !== t49 || $[89] !== t50) {
    t51 = <div className="px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-200 bg-white flex gap-2 sm:gap-3 flex-shrink-0">{t49}{t50}</div>;
    $[88] = t49;
    $[89] = t50;
    $[90] = t51;
  } else {
    t51 = $[90];
  }
  let t52;
  if ($[91] !== t48 || $[92] !== t51) {
    t52 = <>{t48}{t51}</>;
    $[91] = t48;
    $[92] = t51;
    $[93] = t52;
  } else {
    t52 = $[93];
  }
  return t52;
};
export default ClinicalConfidence;